module.exports = __webpack_public_path__ + "img/feedback_card.5b3ce61c.png";